/* __next_internal_client_entry_do_not_use__ default auto */import { jsx as _jsx } from "react/jsx-runtime";
import { FloatBar } from "@/components/blog/FloatBar";
import { useEffect, useState } from "react";
import SharePanel from "../SharePanel";
import { isAndroid, isMobile } from "react-device-detect";
const RenderFooter = param => {
  let {
    showFloatBar = true
  } = param;
  const [isMounted, setIsMounted] = useState(false);
  const [deviceInfo, setDeviceInfo] = useState({
    phone: false,
    androidDevice: false
  });
  useEffect(() => {
    var
      // 设置 referrer URL
      _sessionStorage_setItem, _sessionStorage;
    // 设置挂载状态
    setIsMounted(true);
    setDeviceInfo({
      phone: isMobile,
      androidDevice: isAndroid
    });
    (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : (_sessionStorage_setItem = _sessionStorage.setItem) === null || _sessionStorage_setItem === void 0 ? void 0 : _sessionStorage_setItem.call(_sessionStorage, "refer_url_blog", document.referrer);
  }, []);
  // 在组件挂载前返回 null，避免 hydration mismatch
  if (!isMounted) {
    return null;
  }
  // 根据设备信息渲染不同组件
  if (deviceInfo.phone) {
    return /*#__PURE__*/_jsx(SharePanel, {});
  } else {
    return showFloatBar ? /*#__PURE__*/_jsx(FloatBar, {}) : null;
  }
};
export default RenderFooter;